import React, { useEffect, useState } from "react";
import NavBarDark from "../components/NAVBAR/NavBarDark";
import Footer from "../components/FOOTER/Footer";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import { fetch_event } from "../api/event";
import moment from 'moment';
import GuestList from "../components/GuestList";
import { Calendar, MapPin } from "phosphor-react";


const GuestsList = () => {
  function getQueryParam(name, search) {
    const params = new URLSearchParams(search);
    return params.get(name);
  }

  
  const location = useLocation();
  const event_id = getQueryParam('event_id', location.search);



  const [event, setEvent] = useState(null)
  const [loading, setLoading] = useState(false)
  const [dataFetchFailed, setDataFetchFailed] = useState(false)
  const [errMsg, setErrMsg] = useState('')
  const [rsvpManagerSession, setRsvpManagerSession] = useState(null)


  const [inputValues, setInputValues] = useState({
    communityGroup: null,
    otp: "",
    comment: "",
  });
  const [err, setErr] = useState({    
    otp: "",
    communityGroup: "",
  });
  

  useEffect(() => {
    setUp()
  }, [])

  const setUp = () => {
    try {
      fetchEventData()
    } catch (error) {
      
    }
  }

  const fetchEventData = async () => {
    try {
      setLoading(true)
      
      const params = {
        event_id: event_id ?? '',
      }

      const res = await fetch_event(params)
      const response = await res.json()
      console.log('event', response)
      setLoading(false)
      if (res.ok) {
        setDataFetchFailed(false)
        setEvent(response.data)
        console.log('event', response.data)
      } else {
        setDataFetchFailed(true)
        setErrMsg(response?.message)
      }

    } catch (error) {
      setDataFetchFailed(true)
      setErrMsg("Oops... Something went wrong")
    }
  } 

  const verifyOtp = () => {

  }

  try {
    return (
      <>
        <Helmet>
          <title>
            Pending RSVP - Venco Events | All-in-one Community Management
            Software
          </title>
          <meta
            property="og:title"
            content="Sign up as a Referrer - Venco | All-in-one Community Management Software"
          />
          <meta
            name="twitter:title"
            content="Sign up as a Referrer - Venco | All-in-one Community Management Software"
          />
        </Helmet>
        <NavBarDark />

        <section className="container mx-auto my-10 xl:py-[100px] p-4">
          <div className="mb-8">
            <h1 className="text-[24px] md:text-2xl lg:text-[40px] text-center font-sora font-semibold text-foreground mb-10">
              {event.title} Guests List
            </h1>            
          </div>

          <GuestList 
            event_id={event_id}
            status={"Approved"}
          />
        </section>

        <Footer 
          
        />
      </>
    )
  } catch (error) {
    return (
      <div></div>
    )
  }
}


export default GuestsList;